import React from 'react';
import { Visibility } from 'semantic-ui-react';
import CardsMeasure from './CardsMeasure';
import NoRowsWrapper from '../table/NoRowsWrapper';

const InfiniteScrollCards = ({
  buttonIcon = 'plus',
  buttonText,
  canCreate,
  children,
  className,
  entity,
  handleScroll,
  icon,
  items,
  itemsPerRow,
  loading,
  onClick,
  readErrors,
  readStatus,
  url,
}) => (
  <NoRowsWrapper
    buttonIcon={buttonIcon}
    buttonText={buttonText}
    className={className}
    canCreate={canCreate}
    entity={entity}
    icon={icon}
    items={items}
    loading={loading}
    onClick={onClick}
    readErrors={readErrors}
    readStatus={readStatus}
    url={url}
  >
    <Visibility onBottomVisible={handleScroll} once={false}>
      <CardsMeasure handleScroll={handleScroll} className={className} itemsPerRow={itemsPerRow}>
        {children}
      </CardsMeasure>
    </Visibility>
  </NoRowsWrapper>
);

export default InfiniteScrollCards;
